import dynamic from "next/dynamic";

export const Accordions = dynamic(() => import("./component"));
